import { useState } from 'react';
import { t } from 'i18next';
import {
  Container,
  DescriptionInput,
  EmptyMessageContainer,
  EmptyMessageText,
  NoteContainer,
} from './styles';
import { SectionTitle } from '../Common/SectionTitle/SectionTitle';
import { Note } from './Note';
import IconButton from '@mui/material/IconButton';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import { Loader } from '../Loader/Loader';

interface Props {
  createNote?: (description: string) => void;
  notes?: Note[];
  onSuccessEdit?: () => void;
  containerWidth?: string;
  paddingTitle?: string;
  preventEdit?: boolean;
  isLoading?: boolean;
}

export const NotesBox = ({
  createNote,
  notes = [],
  onSuccessEdit,
  containerWidth,
  paddingTitle,
  preventEdit,
  isLoading
}: Props) => {
  const [showInput, setShowInput] = useState(false);
  const [newNoteDescription, setNewNoteDescription] = useState('');

  const handleClick = () => {
    setShowInput(true);
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setNewNoteDescription(e.target.value);
  };

  const handleConfirm = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    if (newNoteDescription) {
      if (createNote) createNote(newNoteDescription);
    }
    setShowInput(false);
    setNewNoteDescription('');
  };

  const handleCancel = () => {
    setShowInput(false);
    setNewNoteDescription('');
  };

  return (
    <Container width={containerWidth}>
      {<Loader isLoading={!!isLoading} />}
      <SectionTitle
        title={t('candidates.notes')}
        handleAdd={!preventEdit ? () => handleClick() : undefined}
        padding={paddingTitle}
      />
      {showInput && (
        <NoteContainer
          style={{ display: 'flex', alignItems: 'end', justifyContent: 'space-between' }}
        >
          <DescriptionInput
            value={newNoteDescription}
            onChange={handleInputChange}
            placeholder={t('candidates.notes_placeholder')}
          />
          <IconButton onClick={handleConfirm} color="primary">
            <CheckIcon />
          </IconButton>
          <IconButton onClick={handleCancel} color="primary">
            <CloseIcon />
          </IconButton>
        </NoteContainer>
      )}
      {notes.length === 0 && !showInput ? (
        <EmptyMessageContainer>
          <EmptyMessageText>{t('actions.no_elem', { elem: 'notes' })}</EmptyMessageText>
        </EmptyMessageContainer>
      ) : (
        notes.map((note) => <Note key={note.id} note={note} onSuccessEdit={onSuccessEdit} preventEdit={preventEdit} />)
      )}
    </Container>
  );
};
